import Typography from '@ixigo/iui/Typography';
import cn from '@repo/shared/utils/cn';
import { type ReactNode, useEffect, useState } from 'react';
import style from './index.module.css';

interface ContentFaderProps {
	contentList: ReactNode[];
	animationDelay?: number;
	className?: string;
}

export const ContentFader = ({
	contentList,
	animationDelay = 3000,
	className,
}: ContentFaderProps) => {
	const [state, setCurrent] = useState({
		activeIndex: 0,
		lastActiveIndex: -1,
	});

	useEffect(() => {
		const timer = setInterval(() => {
			setCurrent((prevState) => ({
				activeIndex: (prevState.activeIndex + 1) % contentList?.length || 0,
				lastActiveIndex: prevState.activeIndex,
			}));
		}, animationDelay);

		return () => {
			clearInterval(timer);
		};
	}, [animationDelay, contentList?.length]);

	if (!contentList?.length) {
		return null;
	}

	return (
		<div className={cn('overflow-hidden relative', className)}>
			{contentList.map((contentItem, index) => {
				const fadeInClass =
					state.lastActiveIndex === -1 && index === 0
						? style['in-static']
						: index === state.activeIndex
							? style.in
							: '';
				return (
					<div
						className={cn(
							style['content-item'],
							style['line'],
							fadeInClass,
							index === state.lastActiveIndex ? style.out : '',
						)}
						key={index}
					>
						{typeof contentItem === 'string' ? (
							<Typography
								variant="body-lg"
								className="text-center"
								data-testid="content-item"
							>
								{contentItem}
							</Typography>
						) : (
							contentItem
						)}
					</div>
				);
			})}
		</div>
	);
};
